import observer from 'saddlebag-observer';

import { TRACKING } from '../../../../constants';

const track = (
  eventName: string,
  fullSchemaName: string,
  message: { name: string },
) => {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired: true,
  });
};

const trackSmartMetric = (smartMetricName: string) => {
  const payload = {
    name: smartMetricName,
  };

  return track(
    TRACKING.MESSAGES.SMART_METRIC,
    TRACKING.SCHEMAS.SMART_METRIC_SCHEMA,
    payload,
  );
};

export { trackSmartMetric };
